
import { mapGetters, mapMutations } from 'vuex';
import QR from 'qrcode.vue';
import { Dialog } from 'element-ui';
import { sendDynamic } from '@/api/index';
import * as types from '~/types';

export default {
  components: {
    QR,
    ElDialog: Dialog,
  },
  props: ['summary', 'shareUrl', 'type', 'source', 'shareObj'],
  data() {
    return {
      qrSource: null,
      showDialog: false,
      messageData: {
        show: false,
        content: '',
      },
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin']),
    shareSum() {
      if (this.summary) {
        return this.summary.replace(/<.*?>/g, '').substr(0, 80);
      } else {
        return '';
      }
    },
  },
  mounted() {
    const self = this;
    document.querySelector('body').addEventListener('click', self.hideQr, true);
  },
  beforeDestroy() {
    const self = this;
    document.querySelector('body').removeEventListener('click', self.hideQr);
  },
  methods: {
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
    }),
    showQr() {
      this.qrSource = encodeURI(this.shareUrl);
    },
    showWeibo() {
      const url = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
        this.shareUrl
      )}&title=【格隆汇港股资讯】${document.title}${this.shareSum || ''}`;
      window.open(url);
    },
    showQQ() {
      const url = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
        this.shareUrl
      )}&title=【格隆汇港股资讯】${document.title}${this.shareSum || ''}`;
      window.open(url);
    },
    showQzone() {
      const url = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(
        this.shareUrl
      )}&title=【格隆汇港股资讯】${document.title}${this.shareSum || ''}`;
      window.open(url);
    },
    hideQr() {
      this.qrSource = null;
    },
    /**
     * @description 显示转发到社区的dialog
     */
    showCommunity() {
      if (!this.isLogin) {
        this.show(false);
      } else {
        this.showDialog = true;
      }
    },
    /**
     * @description 发送动态
     */
    async sendDynamicHandle(data) {
      const { url, title, content, pictureUrls, authorId, authorNick } =
        data.shareObj;
      const res = await this.$axios(
        sendDynamic({
          topicId: data.topic.topicId,
          content: data.content,
          sharedThingsRequest: {
            url,
            title,
            content,
            pictureUrls,
            authorId,
            authorNick,
          },
          refContents: data.refContents,
        })
      );
      if (res.statusCode === 200) {
        this.messageData.content = '已发布<br>内容审核中';
      } else {
        this.messageData.content = res.message;
      }
      this.messageData.show = true;
    },
    closeMessage() {
      this.messageData.show = false;
      this.showDialog = false;
    },
  },
};
